import { computed } from 'vue';

import { useUISettings } from 'dashboard/composables/useUISettings';

export const DASHBOARD_LAYOUTS = Object.freeze({
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
});

export const DASHBOARD_CONTAINERS = Object.freeze({
  FULL: 'full',
  BOXED: 'boxed',
});

export const normalizeDashboardLayout = value =>
  Object.values(DASHBOARD_LAYOUTS).includes(value)
    ? value
    : DASHBOARD_LAYOUTS.VERTICAL;

export const normalizeDashboardContainer = value =>
  Object.values(DASHBOARD_CONTAINERS).includes(value)
    ? value
    : DASHBOARD_CONTAINERS.FULL;

export function useDashboardLayout() {
  const { uiSettings, updateUISettings } = useUISettings();

  const layout = computed(() =>
    normalizeDashboardLayout(uiSettings.value?.dashboard_layout)
  );
  const container = computed(() =>
    normalizeDashboardContainer(uiSettings.value?.dashboard_container)
  );

  const setLayout = value => {
    updateUISettings({ dashboard_layout: normalizeDashboardLayout(value) });
  };
  const setContainer = value => {
    updateUISettings({
      dashboard_container: normalizeDashboardContainer(value),
    });
  };

  return {
    layout,
    container,
    setLayout,
    setContainer,
  };
}
